import { ElementTypes } from '../element-types';
import { kebabCase } from 'lodash-es';

export class Option {
  private static readonly prefix: string = 'option';
  static readonly Price: string = `${Option.prefix}-${ElementTypes.Div}-price`;
  static readonly VaryExcess: string = `${Option.prefix}-${ElementTypes.Div}-vary-excess`;
  static readonly CarRental: string = `${Option.prefix}-${ElementTypes.Div}-car-rental`;
  static readonly TripCancellation: string = `${Option.prefix}-${ElementTypes.Div}-trip-cancellation`;
  static readonly WinterSport: string = `${Option.prefix}-${ElementTypes.Div}-winter-sport`;
  static readonly CheckWinterSport: string = `${Option.prefix}-${ElementTypes.Checkbox}-winter-sport`;
  static readonly SpecifiedItem: string = `${Option.prefix}-${ElementTypes.Div}-specified-items`;
  static readonly SpecifiedItemName: string = `${Option.prefix}-${ElementTypes.Input}-specified-items-name`;
  static readonly SpecifiedItemValue: string = `${Option.prefix}-${ElementTypes.Input}-specified-items-value`;
  static readonly AddSpecifiedItem: string = `${Option.prefix}-${ElementTypes.Button}-add-specified-items`;
  static readonly CloseSpecifiedItem: string = `${Option.prefix}-${ElementTypes.Link}-close-specified-items`;
  static readonly EditSpecifiedItem: string = `${Option.prefix}-${ElementTypes.Link}-edit-specified-items`;
  static readonly RemoveSpecifiedItem: string = `${Option.prefix}-${ElementTypes.Link}-remove-specified-items`;

  static readonly ProceedToDetails: string = `${Option.prefix}-${ElementTypes.Button}-proceed-to-details`;
  static readonly MainContent: string = `${Option.prefix}-${ElementTypes.Div}-main-content`;
  static readonly ReadMoreLink: string = `${Option.prefix}-${ElementTypes.Link}-read-more`;
  static readonly RevealTitle: string = `${Option.prefix}-${ElementTypes.Link}-reveal-title`;
  static readonly RevealContent: string = `${Option.prefix}-${ElementTypes.Link}-reveal-content`;

  static VaryExcessOptionRadioButton(excessAmount: number): string {
    return `${Option.prefix}-${ElementTypes.RadioButton}-vary-excess-${excessAmount}`;
  }
  static CardRentalOptionRadioButton(excessAmount: number): string {
    return `${Option.prefix}-${ElementTypes.RadioButton}-car-rental-${excessAmount}`;
  }
  static SpecifiedItemSelector(category: string): string {
    return `${Option.prefix}-${
      ElementTypes.Button
    }-specified-items-selector-${kebabCase(category)}`;
  }
  static TripCancellationOptionRadioButton(excessAmount: number): string {
    return `${Option.prefix}-${ElementTypes.RadioButton}-trip-cancellation-${excessAmount}`;
  }
}
